import React, { useEffect, useState } from "react";
import PageHeader from "../../components/ui/PageHeader";
import { Btn, FormInput } from "../../utils/utils";
import "../pages.css";
import { AxiosGet } from "../../api/api";
import Loading from "../../components/ui/Loading";
// import { useNavigate } from "react-router-dom";
import Pagination from "../../utils/pagination";
import EachDev from "../../components/ui/each_dev";

const Developers = () => {
  // const navigate = useNavigate();
  const [searchInp, setSearchInp] = useState("");
  const [curPage, setCurPage] = useState(1);
  const [pagData, setPagData] = useState();
  const [isDevLoad, setIsDevLoad] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [devArr, setDevArr] = useState([]);
  // const url = `developers/properties/?search=${searchInp}&page=${curPage}&page_size=12`;
  const url = `developers/?search=${searchInp}&page=${curPage}&page_size=12`;
  // const [data, setData] = useState({
  //   agentName: "",
  //   agentId: "",
  //   location: "",
  // });
  // const [dataErr, setDataErr] = useState({
  //   agentName: "",
  //   agentId: "",
  //   location: "",
  // });

  const getDevProp = () => {
    setIsDevLoad(true);
    AxiosGet(url)
      .then((res) => {
        // console.log(res);
        setIsDevLoad(false);
        setDevArr(res.data);
        setPagData(res.pagination);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsDevLoad(false);
      });
  };

  const dataChange = (e) => {
    setSearchInp(e.target.value);
  };

  useEffect(() => {
    getDevProp();
    // eslint-disable-next-line
  }, [isSearch, curPage]);

  // const clickProp = (item) => {
  //   localStorage.setItem("property", JSON.stringify(item));
  //   navigate(`/dev-view/${item?.id}`);
  // };

  const clickSearch = () => {
    setIsSearch(!isSearch);
  };
  const clickNext = () => {
    setCurPage(pagData?.nextPage);
  };
  const clickPrev = () => {
    setCurPage(pagData?.previousPage);
  };

  return (
    <div>
      <PageHeader title={"Developers"} text={"Home/ Developers"} />
      <div className="dev_search_comp">
        <div className="search_in">
          <FormInput
            placeholder={"Search by Estate, name or location"}
            changeInput={dataChange}
          />
        </div>
        <Btn
          btnClass={"home-btn"}
          btnClick={clickSearch}
          btnText={"Search Developers"}
        />
      </div>
      {isDevLoad && <Loading />}
      {!isDevLoad && (
        <div className="dev_home_body">
          {devArr?.map((item, i) => {
            return <EachDev key={i} devData={item} />;
          })}
        </div>
      )}
      <Pagination
        pagData={pagData}
        clickNext={clickNext}
        clickPrev={clickPrev}
      />
    </div>
  );
};

export default Developers;
